import { useRouter } from 'next/router';

export const useQueryValue = (query: string) => {
  const router = useRouter();

  const queryValue = router?.query?.[query];

  return queryValue;
};
